export default __webpack_public_path__ + "static/media/laforge0.e9288052.png";